/**
 * 圖片上傳的 resize 規格（processImage 的 sizes 參數）。
 * 新增與編輯流程共用，確保同一內容型別產出的尺寸一致。
 *
 * small 寬度上限須為 600：卡片單張圖以原始寬度顯示、不放大
 * （custom.scss .post-single-image img { width: auto; max-width: 100% }），
 * 寬度不足 600 會撐不滿卡片容器。
 */
export const POST_IMAGE_SIZES = [
  { width: 600, height: 600, prefix: 'small' },
  { width: 1920, height: 1080, prefix: 'big' },
];

export const WORLD_IMAGE_SIZES = [
  { width: 600, height: 1080, prefix: 'small' },
  { width: 1920, height: 1080, prefix: 'big' },
];
